import PreviewCv from "./PreviewCv";

export { PreviewCv as default };
